import React, { useState } from 'react';
import {
  TableRow,
  Box,
  TableCell,
  IconButton,
  Collapse,
  TableHead,
  TableBody,
  FormControl,
  FormHelperText,
  Table,
  Link,
} from '@material-ui/core';
import { KeyboardArrowUp, KeyboardArrowDown } from '@material-ui/icons';
import { Rating } from '@material-ui/lab';
import { useFormikContext, getIn } from 'formik';
import RatingStarIcon from 'assets/icons/svg/RatingStarIcon';
import { IPartnerUgoRating } from '../../interfaces';

interface IProps {
  data: IPartnerUgoRating;
  disabled: boolean;
  partnerIndex: number;
}

const PartnerRatingTableRow = ({ data, disabled, partnerIndex }: IProps) => {
  const [open, setOpen] = useState(false);
  const { touched, errors, setFieldValue } = useFormikContext();

  return (
    <>
      <TableRow>
        <Box component={TableCell} style={{ cursor: 'pointer' }} onClick={() => setOpen(!open)}>
          <Box sx={{ display: 'flex', alignItems: 'center', gridGap: 8 }}>
            <b>{data.smrPartnerName}</b>

            <IconButton aria-label="Развернуть строку" size="small">
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </Box>
        </Box>

        <TableCell>
          <b>{data.nomenclaturaName}</b>
        </TableCell>

        <TableCell>
          <b>{data.applicationNumber}</b>
        </TableCell>

        <TableCell>
          <Link
            href={data.downloadFileInfo?.downloadUrl}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="primary"
          >
            Показать файл
          </Link>
        </TableCell>
      </TableRow>

      <Box component={TableRow} sx={{ borderBottom: 'unset' }}>
        <TableCell colSpan={4} style={{ padding: 0, borderBottom: 'unset' }}>
          <Collapse in={open} unmountOnExit>
            <Table size="small" style={{ tableLayout: 'fixed' }}>
              <TableHead>
                <TableRow>
                  <Box component={TableCell} sx={{ bgcolor: '#F5F5F5' }}>
                    <b>Критерий</b>
                  </Box>

                  <Box component={TableCell} style={{ textAlign: 'center' }} sx={{ bgcolor: '#F5F5F5' }}>
                    <b>Оценка</b>
                  </Box>
                </TableRow>
              </TableHead>

              <TableBody>
                {(data.criteriaRatings || []).map((criteriaRating, criteriaRatingIndex) => {
                  const field = `[${partnerIndex}].criteriaRatings[${criteriaRatingIndex}].value`;
                  const { criteriaRatingId, criteriaRatingName, value } = criteriaRating;

                  return (
                    <TableRow key={criteriaRatingId}>
                      <TableCell>{criteriaRatingName}</TableCell>

                      <TableCell align="center">
                        <FormControl
                          component="fieldset"
                          error={Boolean(getIn(touched, field) && getIn(errors, field))}
                        >
                          <Rating
                            icon={<RatingStarIcon />}
                            name={field}
                            value={value}
                            disabled={disabled}
                            onChange={(_, newValue) => setFieldValue(field, newValue)}
                          />

                          {getIn(touched, field) && getIn(errors, field) && (
                            <FormHelperText>{getIn(errors, field)}</FormHelperText>
                          )}
                        </FormControl>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </Box>
    </>
  );
};

export default PartnerRatingTableRow;
